import { BoilerBrand, BoilerModel, DefaultGetQuotesOptions } from '../types';

export const defaultGetQuotesOptions: DefaultGetQuotesOptions = {
  isAbs: false,
  isGuestHouse: false,
  isLandlord: false,
  isHomeRecover: false,
  boilerMake: BoilerBrand.DEFAULT,
  boilerModel: BoilerModel.VALID,
  boilerAge: 0,
  promoCode: '',
  isLoggedIn: true,
};
